module.exports = __webpack_public_path__ + "img/OgreMagi.c066d965.png";